module.exports = __webpack_public_path__ + "media/newstyle/images/cta-mobile-red-78bb47a922e9b5c328e36cdd13317ca9.png";